import { j as p } from "../../../jsx-runtime-B6kdoens.js";
import { useRef as m, useMemo as f } from "react";
import { c as l } from "../../../create-component-CBAeEoQ6.js";
import { CheckboxGroupBase as d } from "../../Checkbox/CheckboxGroup/index.js";
const x = l(
  "ToggleGroup",
  ({ onChange: r, type: o = "checkbox", value: u, values: c, ...s }) => {
    const e = m(
      Array.isArray(c) ? [...c] : []
    ), i = f(() => {
      if (r)
        return o === "radio" ? (t) => {
          r == null || r(t, t.target.value);
        } : (t) => {
          t.target.checked ? e.current.push(t.target.value) : e.current.splice(
            e.current.indexOf(t.target.value),
            1
          ), r == null || r(t, [...e.current]);
        };
    }, [r, o]);
    return /* @__PURE__ */ p.jsx(
      d,
      {
        onChange: i,
        value: u !== void 0 ? u : c,
        type: o,
        ...s
      }
    );
  }
);
x.defaultProps = {
  type: "checkbox"
};
export {
  x as ToggleGroup
};
//# sourceMappingURL=index.js.map
